import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=56e805ac&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=56e805ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e805ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e805ac')) {
      api.createRecord('56e805ac', component.options)
    } else {
      api.reload('56e805ac', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=56e805ac&scoped=true&", function () {
      api.rerender('56e805ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R6z7Pyy3zMgI/JS/comp/DateRangeExt.vue"
export default component.exports